import React from "react";
import {StyledContentTableHeader} from "../StyledComponents";
import {MotorcycleImageComponent} from "../MotorcycleImageComponent";
import {IMotorcycle} from "../../../interfaces/Interfaces";

interface MotorcycleRowProps {
    motorcycle: IMotorcycle;
    onRemove: (id: number) => void;
}

export const MotorcycleTableRow: React.FC<MotorcycleRowProps> = ({
    motorcycle,
    onRemove,
}) => {
    return (
        < >
            <StyledContentTableHeader>
                <MotorcycleImageComponent
                    motorcycle={motorcycle}
                    onClose={() => onRemove(motorcycle.id)}
                />
            </StyledContentTableHeader>
        </ >
    );
};
